import axios from "axios";
import moment from "moment-timezone";
import { Routes } from "./classes/Routes";
import { auth } from "./firebase";
import { getImitateSession } from "./shared/imitateStorage";

const hostname = window && window.location && window.location.hostname;

let apiPath = "/";
let withCredentials = false;
if (hostname === "localhost") {
  apiPath = "http://localhost:8080/";
  withCredentials = true;
}

const instance = axios.create({
  baseURL: apiPath,
  withCredentials: withCredentials,
});

instance.interceptors.request.use(async (config) => {
  const firebaseToken = await auth.currentUser?.getIdToken();
  config.headers["X-Auth"] = `Bearer ${firebaseToken ? firebaseToken : ""}`;
  config.headers["X-TimeZoneName"] = moment.tz.guess();

  // Do not inject impersonation headers for login/logout requests
  const isAuthEndpoint =
    config.url &&
    (config.url.includes("/auth/login") || config.url.includes("/auth/logout"));
  const imitate = isAuthEndpoint ? null : getImitateSession();
  if (imitate) {
    if (imitate.userId) {
      config.headers["X-Imitate-User-Id"] = String(imitate.userId);
    }
    if (imitate.orgId) {
      config.headers["X-Imitate-Org-Id"] = String(imitate.orgId);
    }
    if (imitate.level) {
      config.headers["X-Imitate-Level"] = imitate.level;
    }
    if (imitate.allowWrite) {
      config.headers["X-Imitate-Allow-Write"] = "true";
    }
  }

  return config;
});

instance.interceptors.response.use(
  (config) => config,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    let response = error?.response;
    if (!response) {
      response = { data: "Server error! Please contact support.", status: 503 };
    } else if (response.status === 500 || response.status === 405) {
      response.data = "Server error! Please contact support.";
    }
    if (response && response.status === 401) {
      if (window.location.pathname !== Routes.LOGIN) {
        window.location.href = `${Routes.LOGIN}${window.location.search}`;
      }
    }
    return Promise.reject({ response });
  }
);

export default instance;
